import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://vladriver-vtc.fr";

const SEO = ({ title, description, canonical, ogImage, schema, lang = "fr", noindex = false }) => {
  const url = canonical?.startsWith("http") ? canonical : `${SITE}${canonical || ""}`;
  const img = ogImage || "/brand/og-image.jpg";

  // Static SEO tags from index.html / prerender are only for crawlers; React 19 hoists its own.
  useEffect(() => {
    document.head.querySelectorAll('[data-rh="true"]').forEach((el) => el.remove());
  }, []);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
